import React, { useEffect, useState, useCallback } from "react";
import MockTestReading, { MockReadingData, MockQuizQuestion } from "../../components/SatCourse/MockTestReading";
import { useLocation, useNavigate } from "react-router-dom";
// @ts-ignore
import useTabVisibility from "./SatCheckVisibility";

const MOckTestReadingScreen: React.FC = () => {
  const [isLoading] = useState<boolean>(false);
  const [isError] = useState<string>("");
  const navigate = useNavigate();
  const uselocation = useLocation();
  const title = uselocation.state?.title || "";
  const isTabVisible = useTabVisibility();

  useEffect(() => {
    if (isTabVisible) {
      console.log("Tab is now visible");
    } else {
      console.log("Tab is now hidden");
    }
  }, [isTabVisible]);

  const [readingData] = useState<MockReadingData[]>([
    {
      readingparagraph:
        "This passage is from Carlos Ruiz Zafón, The Angel’s Game. ©2008 by Dragonworks, S.L. Translation ©2009 by Lucia Graves. The narrator, a writer, recalls his childhood in early twentieth-century Barcelona This passage is from Carlos Ruiz Zafón, The Angel’s Game. ©2008 by Dragonworks, S.L. Translation ©2009 by Lucia Graves. The narrator, a writer, recalls his childhood in early twentieth-century Barcelona.Beginning of reading passage. Even then my only friends were made of paper and ink.Beginning of reading passage. Even then my only friends were made of paper and ink. At school I had learned to read and write long before the other children. Where my school friends saw notches of ink on incomprehensible pages, I saw light, streets, and people. Words and the mystery of their hidden science fascinated me, and I saw in them a key with which I could unlock a boundless world, a safe haven from that home.This passage is from Carlos Ruiz Zafón, The Angel’s Game. ©2008 by Dragonworks, S.L. Translation ©2009 by Lucia Graves. The narrator, a writer, recalls his childhood in early twentieth-century Barcelona.",
    },
  ]);

  const [quizQuestions] = useState<MockQuizQuestion[]>([
    {
      questionNo: "Which choice best describes what happens in the passage?",
      choices: [
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
      ],
    },
    {
      questionNo: "Which choice best describes what happens in the passage?",
      choices: [
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
      ],
    },
    {
      questionNo: "Which choice best describes what happens in the passage?",
      choices: [
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
      ],
    },
    {
      questionNo: "Which choice best describes what happens in the passage?",
      choices: [
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
      ],
    },
    {
      questionNo: "Which choice best describes what happens in the passage?",
      choices: [
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
        { choiceno: "One character receives a surprising request from another character." },
      ],
    },
  ]);

  const HandleId = useCallback(() => {
    console.log("GOOD WORK");
  }, []);

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <>
      <MockTestReading
        isError={isError}
        isLoading={isLoading}
        HandleId={HandleId}
        title={title}
        readingData={readingData}
        quizQuestions={quizQuestions}
        goBack={goBack}
      />
    </>
  );
};
export default MOckTestReadingScreen;
